export default function runToolbarActionCallback(param) {
  var action = param.action;
  var callback = action.callback;
  try {
    return callback && callback(action);
  } catch (e) {
    if (e instanceof Error) {
      console.warn(e.stack);
    }
  }
}
;